<template>
  <div class="layout-container">
    <CRNavigation
      v-append-parameters="urlParams"
      :branding-global="jobShop?.branding"
      :navigation-global="jobShop?.navigation"
      :social-media-global="jobShop?.['social-media']"
      :page-locale="jobShop?.locale"
      :job-shop-url="jobShop?.jobShopUrl"
      @emitted-click="
        (e) => {
          trackNavigationClicked(e);
        }
      "
    />

    <main class="main-container">
      <slot />
    </main>

    <CRFooter
      v-append-parameters="urlParams"
      :social-media-global="jobShop?.['social-media']"
      :navigation-global="jobShop?.navigation"
      :branding-global="jobShop?.branding"
      :footer-global="jobShop?.footer"
      :job-shop-url="jobShop?.jobShopUrl"
      @cookie-settings-click="$cookieConsent.openCookieSettings()"
    />
  </div>
</template>

<script setup lang="ts">
import { useJobShopData } from "@/composables/useJobShopData"
import { useTypesenseApiKey } from "@/composables/useTypesenseApiKey"

const { $cookieConsent } = useNuxtApp()
const urlParams = useQueryHeaders(useRequestHeaders())

// Fetch JobShop data
const { jobShop, jobShopStatus, jobShopError } = await useJobShopData()

// Fetch typesenseApiKey
await useTypesenseApiKey()

// Set fonts & font-weights
useFonts(jobShop?.value)

// set font size class
useHeadingFontClass(jobShop?.value)

// Use JobShop data to set the favicon with useHeadSafe
const brandingConfig = jobShop.value?.branding.config.general

useHeadSafe({
  htmlAttrs: {
    lang: jobShop.value?.locale,
  },
  link: [
    {
      rel: "icon",
      href: brandingConfig?.favicon.media.url,
    },
  ],
})

// Add WebSite schema
if (jobShop.value) {
  useSchemaOrg([
    defineWebSite({
      "@id": `${jobShop.value.jobShopUrl}#website`,
      "name": jobShop.value.jobShopTitle,
      "url": jobShop.value.jobShopUrl,
      "inLanguage": jobShop.value.locale,
    }),
  ])
}
</script>

<style lang="scss" scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-height: 100%;
}

.main-container {
  flex: 1;
}
</style>
